/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import React from "react";

import { formatCurrentTime } from "../../../../../../shared/utils/time";
import { usePlayerAdvertisementTracker } from "../../../../../BasePlayer";

import "./TimeMarker.scss";

export const TimeMarker = () => {
  const {
    tracker: { currentTime, duration },
  } = usePlayerAdvertisementTracker();

  const timeMarker = `${formatCurrentTime(currentTime)} / ${formatCurrentTime(
    duration,
  )}`;

  return <div className="TimeMarker">{timeMarker}</div>;
};
